import { getLanguageParam } from '@sportal365/smp-widget-utils';
import { SDKOptions } from '../types';
import { Buffer } from 'buffer';

export interface IRequestHeadersRelated {
  'X-Project': string;
  Authorization: string;
  'Accept-Language': string;
}

// filters out undefined or empty string values
const clearParams = (params: { [key: string]: string | string[] }) => {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== '')
    .reduce((obj, key) => {
      obj[key] = params[key];
      return obj;
    }, {} as { [key: string]: string | string[] });
};

export const generateRequest = async <TParams extends Record<string, any>>(url: string, params: TParams, sdkOptions: SDKOptions) => {
  const requestUrl = new URL(url);
  Object.keys({ ...clearParams(params) }).forEach((key) => requestUrl.searchParams.append(key, params[key]));

  const response = await fetch(requestUrl.toString(), {
    method: 'GET',

    headers: {
      'X-Project': sdkOptions.dataConfigProject,
      Authorization: `Basic ${Buffer.from(sdkOptions.dataConfigApiKey).toString('base64')}`,
      'Accept-Language': getLanguageParam(sdkOptions.dataConfigLang),
    },
  });

  return response.json();
};
